<ds-modal
  #dataPrivacyDisclaimersModal
  [ds-modal-trigger-for]="dataPrivacyDisclaimersModal"
  [isModalOpen]="modalIsOpen()"
  [dimensionsConfig]="{ width: '585px' }"
  [isDismissable]="true"
  (isModalOpenChange)="modalIsOpen.set($event)"
  (modalDismiss)="modalDismissed()"
>
  <ds-box-header size="md">{{ 'header.dataPrivacyDisclaimersModal.title' | translate }}</ds-box-header>
  <ds-box-content>
    <div>
      <p class="text-regular bold-600 mb-4x">
        {{ 'header.dataPrivacyDisclaimersModal.firstSection.title' | translate }}
      </p>
      <ol class="text-regular mb-8x">
        <li>{{ 'header.dataPrivacyDisclaimersModal.firstSection.content.rulesAndRegulations' | translate }}</li>
        <li>
          {{ 'header.dataPrivacyDisclaimersModal.firstSection.content.sGateDataProtection' | translate
          }}<a
            href="{{ 'header.dataPrivacyDisclaimersModal.firstSection.content.sGateDataProtectionLink' | translate }}"
            >{{ 'header.dataPrivacyDisclaimersModal.firstSection.content.sGateDataProtectionLink' | translate }}</a
          >{{ 'header.dataPrivacyDisclaimersModal.firstSection.content.sGateDataProtectionPure' | translate }}
        </li>
        <li>{{ 'header.dataPrivacyDisclaimersModal.firstSection.content.yourData' | translate }}</li>
      </ol>
    </div>
    <div>
      <p class="text-regular bold-600 mb-4x">
        {{ 'header.dataPrivacyDisclaimersModal.secondSection.title' | translate }}
      </p>
      <p class="text-regular mb-8x">{{ 'header.dataPrivacyDisclaimersModal.secondSection.content' | translate }}</p>
    </div>
    <div>
      <p class="text-regular bold-600 mb-4x">
        {{ 'header.dataPrivacyDisclaimersModal.thirdSection.title' | translate }}
      </p>
      <p class="text-regular mb-8x">{{ 'header.dataPrivacyDisclaimersModal.thirdSection.content' | translate }}</p>
    </div>
    <div>
      <p class="text-regular bold-600 mb-4x">
        {{ 'header.dataPrivacyDisclaimersModal.fourthSection.title' | translate }}
      </p>
      <p class="text-regular">
        {{ 'header.dataPrivacyDisclaimersModal.fourthSection.content.paragraph1' | translate }}
      </p>
      <ul class="text-regular mb-8x">
        <li>{{ 'header.dataPrivacyDisclaimersModal.fourthSection.content.bulletPoint1' | translate }}</li>
        <li>{{ 'header.dataPrivacyDisclaimersModal.fourthSection.content.bulletPoint2' | translate }}</li>
        <li>{{ 'header.dataPrivacyDisclaimersModal.fourthSection.content.bulletPoint3' | translate }}</li>
        <li>{{ 'header.dataPrivacyDisclaimersModal.fourthSection.content.bulletPoint4' | translate }}</li>
      </ul>
    </div>
    <div>
      <p class="text-regular bold-600 mb-4x">
        {{ 'header.dataPrivacyDisclaimersModal.fifthSection.title' | translate }}
      </p>
      <p class="text-regular mb-4x">
        {{ 'header.dataPrivacyDisclaimersModal.fifthSection.content.paragraph1' | translate }}
      </p>
      <p class="text-regular bold-600">
        {{ 'header.dataPrivacyDisclaimersModal.fifthSection.content.numberedPoint1.title' | translate }}
      </p>
      <p class="text-regular mb-4x">
        {{ 'header.dataPrivacyDisclaimersModal.fifthSection.content.numberedPoint1.content' | translate }}
      </p>
      <p class="text-regular bold-600">
        {{ 'header.dataPrivacyDisclaimersModal.fifthSection.content.numberedPoint2.title' | translate }}
      </p>
      <p class="text-regular mb-4x">
        {{ 'header.dataPrivacyDisclaimersModal.fifthSection.content.numberedPoint2.content' | translate }}
      </p>
      <p class="text-regular bold-600">
        {{ 'header.dataPrivacyDisclaimersModal.fifthSection.content.numberedPoint3.title' | translate }}
      </p>
      <p class="text-regular mb-8x">
        {{ 'header.dataPrivacyDisclaimersModal.fifthSection.content.numberedPoint3.content' | translate }}
      </p>
    </div>
    <div>
      <p class="text-regular bold-600 mb-4x">
        {{ 'header.dataPrivacyDisclaimersModal.sixthSection.title' | translate }}
      </p>
      <p class="text-regular mb-8x">
        {{ 'header.dataPrivacyDisclaimersModal.sixthSection.content.paragraph1' | translate }}
      </p>
      <p class="text-regular bold-600 mb-4x">
        {{ 'header.dataPrivacyDisclaimersModal.sixthSection.content.articleA.title' | translate }}
      </p>
      <p class="text-regular bold-600">
        {{ 'header.dataPrivacyDisclaimersModal.sixthSection.content.articleA.numberedPoint1.title' | translate }}
      </p>
      <p class="text-regular mb-4x">
        {{ 'header.dataPrivacyDisclaimersModal.sixthSection.content.articleA.numberedPoint1.content' | translate }}
      </p>
      <p class="text-regular bold-600">
        {{ 'header.dataPrivacyDisclaimersModal.sixthSection.content.articleA.numberedPoint2.title' | translate }}
      </p>
      <p class="text-regular mb-4x">
        {{ 'header.dataPrivacyDisclaimersModal.sixthSection.content.articleA.numberedPoint2.content' | translate }}
      </p>
      <p class="text-regular bold-600">
        {{ 'header.dataPrivacyDisclaimersModal.sixthSection.content.articleA.numberedPoint3.title' | translate }}
      </p>
      <p class="text-regular mb-8x">
        {{ 'header.dataPrivacyDisclaimersModal.sixthSection.content.articleA.numberedPoint3.content' | translate }}
      </p>
      <p class="text-regular bold-600 mb-4x">
        {{ 'header.dataPrivacyDisclaimersModal.sixthSection.content.articleB.title' | translate }}
      </p>
      <p class="text-regular mb-4x">
        {{ 'header.dataPrivacyDisclaimersModal.sixthSection.content.articleB.paragraph1' | translate }}
      </p>
      <p class="text-regular mb-8x">
        {{ 'header.dataPrivacyDisclaimersModal.sixthSection.content.articleB.paragraph2' | translate }}
      </p>
      <p class="text-regular bold-600 mb-4x">
        {{ 'header.dataPrivacyDisclaimersModal.sixthSection.content.articleC.title' | translate }}
      </p>
      <p class="text-regular mb-4x">
        {{ 'header.dataPrivacyDisclaimersModal.sixthSection.content.articleC.paragraph1' | translate }}
      </p>
      <p class="text-regular mb-4x">
        {{ 'header.dataPrivacyDisclaimersModal.sixthSection.content.articleC.paragraph2' | translate }}
      </p>
      <p class="text-regular mb-4x">
        {{ 'header.dataPrivacyDisclaimersModal.sixthSection.content.articleC.paragraph3' | translate }}
      </p>
      <p class="text-regular">
        {{ 'header.dataPrivacyDisclaimersModal.sixthSection.content.articleC.paragraph4' | translate }}
      </p>
      <ul>
        <li class="text-regular">
          {{ 'header.dataPrivacyDisclaimersModal.sixthSection.content.articleC.bulletPoint1' | translate }}
        </li>
        <li class="text-regular">
          {{ 'header.dataPrivacyDisclaimersModal.sixthSection.content.articleC.bulletPoint2' | translate }}
        </li>
        <li class="text-regular">
          {{ 'header.dataPrivacyDisclaimersModal.sixthSection.content.articleC.bulletPoint3' | translate }}
        </li>
        <li class="text-regular">
          {{ 'header.dataPrivacyDisclaimersModal.sixthSection.content.articleC.bulletPoint4' | translate }}
        </li>
        <li class="text-regular">
          {{ 'header.dataPrivacyDisclaimersModal.sixthSection.content.articleC.bulletPoint5' | translate }}
        </li>
        <li class="text-regular">
          {{ 'header.dataPrivacyDisclaimersModal.sixthSection.content.articleC.bulletPoint6' | translate }}
        </li>
        <li class="text-regular">
          {{ 'header.dataPrivacyDisclaimersModal.sixthSection.content.articleC.bulletPoint7' | translate }}
        </li>
        <li class="text-regular mb-4x">
          {{ 'header.dataPrivacyDisclaimersModal.sixthSection.content.articleC.bulletPoint8' | translate }}
        </li>
      </ul>
      <p class="text-regular mb-8x">
        {{ 'header.dataPrivacyDisclaimersModal.sixthSection.content.articleC.paragraph5' | translate }}
      </p>
      <p class="text-regular bold-600 mb-4x">
        {{ 'header.dataPrivacyDisclaimersModal.sixthSection.content.articleD.title' | translate }}
      </p>
      <p class="text-regular mb-8x">
        {{ 'header.dataPrivacyDisclaimersModal.sixthSection.content.articleD.content' | translate }}
      </p>
    </div>
    <div>
      <p class="text-regular bold-600 mb-4x">
        {{ 'header.dataPrivacyDisclaimersModal.seventhSection.title' | translate }}
      </p>
      <p class="text-regular mb-4x">
        {{ 'header.dataPrivacyDisclaimersModal.seventhSection.content.paragraph1' | translate }}
      </p>
      <p class="text-regular mb-4x">
        {{ 'header.dataPrivacyDisclaimersModal.seventhSection.content.paragraph2' | translate }}
      </p>
      <ul>
        <li class="text-regular">
          {{ 'header.dataPrivacyDisclaimersModal.seventhSection.content.bulletPoint1' | translate }}
        </li>
        <li class="text-regular">
          {{ 'header.dataPrivacyDisclaimersModal.seventhSection.content.bulletPoint2' | translate }}
        </li>
        <li class="text-regular">
          {{ 'header.dataPrivacyDisclaimersModal.seventhSection.content.bulletPoint3' | translate }}
        </li>
        <li class="text-regular">
          {{ 'header.dataPrivacyDisclaimersModal.seventhSection.content.bulletPoint4' | translate }}
        </li>
        <li class="text-regular">
          {{ 'header.dataPrivacyDisclaimersModal.seventhSection.content.bulletPoint5' | translate }}
        </li>
        <li class="text-regular mb-4x">
          {{ 'header.dataPrivacyDisclaimersModal.seventhSection.content.bulletPoint6' | translate }}
        </li>
      </ul>
      <p class="text-regular mb-8x">
        {{ 'header.dataPrivacyDisclaimersModal.seventhSection.content.paragraph3' | translate }}
      </p>
    </div>
    <div>
      <p class="text-regular bold-600 mb-4x">
        {{ 'header.dataPrivacyDisclaimersModal.eighthSection.title' | translate }}
      </p>
      <p class="text-regular mb-8x">
        {{ 'header.dataPrivacyDisclaimersModal.eighthSection.content' | translate }}
      </p>
    </div>
    <div>
      <p class="text-regular bold-600 mb-4x">
        {{ 'header.dataPrivacyDisclaimersModal.ninthSection.title' | translate }}
      </p>
      <p class="text-regular mb-4x">
        {{ 'header.dataPrivacyDisclaimersModal.ninthSection.content.paragraph1' | translate }}
      </p>
      <p class="text-regular mb-8x">
        {{ 'header.dataPrivacyDisclaimersModal.ninthSection.content.paragraph2' | translate }}
      </p>
    </div>
    <div>
      <p class="text-regular bold-600 mb-4x">
        {{ 'header.dataPrivacyDisclaimersModal.tenthSection.title' | translate }}
      </p>
      <p class="text-regular mb-8x">
        {{ 'header.dataPrivacyDisclaimersModal.tenthSection.content' | translate }}
      </p>
    </div>
    <div>
      <p class="text-regular bold-600 mb-4x">
        {{ 'header.dataPrivacyDisclaimersModal.eleventhSection.title' | translate }}
      </p>
      <p class="text-regular mb-8x">
        {{ 'header.dataPrivacyDisclaimersModal.eleventhSection.content' | translate }}
      </p>
    </div>
    <div>
      <p class="text-regular bold-600 mb-4x">
        {{ 'header.dataPrivacyDisclaimersModal.twelfthSection.title' | translate }}
      </p>
      <p class="text-regular mb-4x">
        {{ 'header.dataPrivacyDisclaimersModal.twelfthSection.content.paragraph1' | translate }}
      </p>
      <p class="text-regular mb-4x">
        {{ 'header.dataPrivacyDisclaimersModal.twelfthSection.content.paragraph2' | translate }}
      </p>
      <p class="text-regular mb-8x">
        {{ 'header.dataPrivacyDisclaimersModal.twelfthSection.content.paragraph3' | translate }}
      </p>
    </div>
    <div>
      <p class="text-regular bold-600 mb-4x">
        {{ 'header.dataPrivacyDisclaimersModal.thirteenthSection.title' | translate }}
      </p>
      <p class="text-regular">
        {{ 'header.dataPrivacyDisclaimersModal.thirteenthSection.content.paragraph1' | translate }}
      </p>
      <a href="mailto:{{ 'header.dataPrivacyDisclaimersModal.thirteenthSection.content.email1' | translate }}">{{
        'header.dataPrivacyDisclaimersModal.thirteenthSection.content.email1' | translate
      }}</a>
      <br />
      <a href="mailto:{{ 'header.dataPrivacyDisclaimersModal.thirteenthSection.content.email2' | translate }}">{{
        'header.dataPrivacyDisclaimersModal.thirteenthSection.content.email2' | translate
      }}</a>
      <p class="text-regular">
        {{ 'header.dataPrivacyDisclaimersModal.thirteenthSection.content.paragraph2' | translate }}
      </p>
      <p class="text-regular mb-4x">
        {{ 'header.dataPrivacyDisclaimersModal.thirteenthSection.content.paragraph3' | translate }}
      </p>
      <p class="text-regular">
        {{ 'header.dataPrivacyDisclaimersModal.thirteenthSection.content.paragraph4' | translate }}
      </p>
      <ul>
        <li class="text-regular">
          {{ 'header.dataPrivacyDisclaimersModal.thirteenthSection.content.bulletPoint1' | translate }}
        </li>
        <li class="text-regular">
          {{ 'header.dataPrivacyDisclaimersModal.thirteenthSection.content.bulletPoint2' | translate }}
        </li>
        <li class="text-regular">
          {{ 'header.dataPrivacyDisclaimersModal.thirteenthSection.content.bulletPoint3' | translate }}
        </li>
        <li class="text-regular">
          {{ 'header.dataPrivacyDisclaimersModal.thirteenthSection.content.bulletPoint4' | translate }}
        </li>
        <li class="text-regular mb-4x">
          <a
            href="mailto:{{ 'header.dataPrivacyDisclaimersModal.thirteenthSection.content.bulletPoint5' | translate }}"
            >{{ 'header.dataPrivacyDisclaimersModal.thirteenthSection.content.bulletPoint5' | translate }}</a
          >
        </li>
      </ul>
      <p class="text-regular mb-8x">
        {{ 'header.dataPrivacyDisclaimersModal.thirteenthSection.content.paragraph5' | translate }}
      </p>
    </div>
    <div>
      <p class="text-regular bold-600 mb-4x">
        {{ 'header.dataPrivacyDisclaimersModal.fourteenthSection.title' | translate }}
      </p>
      <p class="text-regular mb-8x">
        {{ 'header.dataPrivacyDisclaimersModal.fourteenthSection.content.paragraph1' | translate }}
      </p>
      <p class="text-regular bold-600 mb-4x">
        {{ 'header.dataPrivacyDisclaimersModal.fourteenthSection.content.articleA.title' | translate }}
      </p>
      <p class="text-regular mb-8x">
        {{ 'header.dataPrivacyDisclaimersModal.fourteenthSection.content.articleA.paragraph1' | translate }}
      </p>
      <p class="text-regular bold-600 mb-4x">
        {{ 'header.dataPrivacyDisclaimersModal.fourteenthSection.content.articleB.title' | translate }}
      </p>
      <p class="text-regular mb-8x">
        {{ 'header.dataPrivacyDisclaimersModal.fourteenthSection.content.articleB.paragraph1' | translate }}
      </p>
      <p class="text-regular bold-600 mb-4x">
        {{ 'header.dataPrivacyDisclaimersModal.fourteenthSection.content.articleC.title' | translate }}
      </p>
      <p class="text-regular">
        {{ 'header.dataPrivacyDisclaimersModal.fourteenthSection.content.articleC.paragraph1' | translate }}
      </p>
      <ul>
        <li class="text-regular">
          {{ 'header.dataPrivacyDisclaimersModal.fourteenthSection.content.articleC.bulletPoint1' | translate }}
        </li>
        <li class="text-regular">
          {{ 'header.dataPrivacyDisclaimersModal.fourteenthSection.content.articleC.bulletPoint2' | translate }}
        </li>
        <li class="text-regular">
          {{ 'header.dataPrivacyDisclaimersModal.fourteenthSection.content.articleC.bulletPoint3' | translate }}
        </li>
        <li class="text-regular">
          {{ 'header.dataPrivacyDisclaimersModal.fourteenthSection.content.articleC.bulletPoint4' | translate }}
        </li>
        <li class="text-regular mb-8x">
          {{ 'header.dataPrivacyDisclaimersModal.fourteenthSection.content.articleC.bulletPoint5' | translate }}
        </li>
      </ul>
      <p class="text-regular bold-600 mb-4x">
        {{ 'header.dataPrivacyDisclaimersModal.fourteenthSection.content.articleD.title' | translate }}
      </p>
      <p class="text-regular">
        {{ 'header.dataPrivacyDisclaimersModal.fourteenthSection.content.articleD.paragraph1' | translate }}
      </p>
      <ul>
        <li class="text-regular">
          {{ 'header.dataPrivacyDisclaimersModal.fourteenthSection.content.articleD.bulletPoint1' | translate }}
        </li>
        <li class="text-regular">
          {{ 'header.dataPrivacyDisclaimersModal.fourteenthSection.content.articleD.bulletPoint2' | translate }}
        </li>
        <li class="text-regular">
          {{ 'header.dataPrivacyDisclaimersModal.fourteenthSection.content.articleD.bulletPoint3' | translate }}
        </li>
        <li class="text-regular mb-8x">
          {{ 'header.dataPrivacyDisclaimersModal.fourteenthSection.content.articleD.bulletPoint4' | translate }}
        </li>
      </ul>
      <p class="text-regular bold-600 mb-4x">
        {{ 'header.dataPrivacyDisclaimersModal.fourteenthSection.content.articleE.title' | translate }}
      </p>
      <p class="text-regular mb-8x">
        {{ 'header.dataPrivacyDisclaimersModal.fourteenthSection.content.articleE.paragraph1' | translate }}
      </p>
      <p class="text-regular bold-600 mb-4x">
        {{ 'header.dataPrivacyDisclaimersModal.fourteenthSection.content.articleF.title' | translate }}
      </p>
      <p class="text-regular mb-8x">
        {{ 'header.dataPrivacyDisclaimersModal.fourteenthSection.content.articleF.paragraph1' | translate }}
      </p>
    </div>
    <div>
      <p class="text-regular bold-600 mb-4x">
        {{ 'header.dataPrivacyDisclaimersModal.fifteenthSection.title' | translate }}
      </p>
      <p class="text-regular mb-8x">
        {{ 'header.dataPrivacyDisclaimersModal.fifteenthSection.content' | translate }}
      </p>
    </div>
    <div>
      <p class="text-regular bold-600 mb-4x">
        {{ 'header.dataPrivacyDisclaimersModal.sixteenthSection.title' | translate }}
      </p>
      <p class="text-regular mb-8x">
        {{ 'header.dataPrivacyDisclaimersModal.sixteenthSection.content' | translate }}
      </p>
    </div>
    <div>
      <p class="text-regular bold-600 mb-4x">
        {{ 'header.dataPrivacyDisclaimersModal.seventeenthSection.title' | translate }}
      </p>
      <p class="text-regular mb-8x">
        {{ 'header.dataPrivacyDisclaimersModal.seventeenthSection.content' | translate }}
      </p>
    </div>
  </ds-box-content>
  <ds-box-footer>
    <button id="btn-close-modal" ds-button #dsModalDismissElement>
      {{ 'common.buttons.close' | translate }}
    </button>
  </ds-box-footer>
</ds-modal>
